import { useState } from "react";
import Seo, { breadcrumbs, faqSchema } from "../components/Seo";
import { SectionHeader } from "../components/UI";

const FAQS = [
  { cat: "New Vehicles", q: "Is the inventory live?", a: "Yes — inventory is pulled from a read-only vAuto feed. Confirm availability with Scott before traveling." },
  { cat: "Used Vehicles", q: "Can Scott confirm availability?", a: "Yes. Text Scott from any vehicle card and he'll confirm before you head over." },
  { cat: "New & Used", q: "Can I shop both new and used vehicles?", a: "Yes — they're shown as separate, dedicated experiences so you can shop the way that fits you." },
  { cat: "New & Used", q: "Can Scott help me compare new vs used?", a: "Yes — it's one of the most common conversations. See the New vs Used Guide too." },
  { cat: "Build My Own Deal", q: "Can I build my own deal?", a: "Yes — choose a vehicle, add trade and accessories, and send it to Scott to take the next step." },
  { cat: "Build My Own Deal", q: "Is Build My Own Deal a final price or payment?", a: "No. It's for planning and discussion. Final terms are confirmed by the dealership and lender." },
  { cat: "Trade-Ins", q: "Can I include my trade?", a: "Yes — submit your vehicle details and run the dealer-grade trade valuation for an instant starting point." },
  { cat: "Trade-Ins", q: "How does Scott estimate my trade value?", a: "Scott's site uses a wholesale-first dealer valuation engine that factors in your year, make, model, trim, mileage, condition, history, region, and equipment to give you a realistic range." },
  { cat: "Accessories", q: "Can I add Chevrolet accessories?", a: "Yes — shop the official Chevrolet accessories catalog and let Scott know what you'd like added." },
  { cat: "Payments", q: "Where do I apply for financing?", a: "Through the official Byers Chevrolet finance application page linked from the site." },
  { cat: "Payments", q: "Can I ask about payments?", a: "Yes — share your goal and Scott will help plan around it." },
  { cat: "Trade-Ins", q: "Can I trade my current vehicle?", a: "Yes — Scott welcomes trades of all makes and models." },
  { cat: "Service Area", q: "Do you serve my area?", a: "Scott helps customers across Grove City, Columbus, Hilliard, Dublin, Gahanna, Westerville, Pickerington, Reynoldsburg, and surrounding Central Ohio communities within 50 miles." },
  { cat: "Website Accuracy", q: "Are prices and payments guaranteed?", a: "No. Prices, payments, and inventory are subject to change and must be confirmed with the dealership." },
  { cat: "Website Accuracy", q: "Does this website replace the dealership website?", a: "No. This website is a personal sales and follow-up tool. Inventory data is provided through a read-only inventory feed and should always be confirmed with the dealership." },
];

const CATS = ["All", ...Array.from(new Set(FAQS.map((f) => f.cat)))];

export default function Faq() {
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? FAQS : FAQS.filter((f) => f.cat === cat);
  return (
    <main id="main-content">
      <Seo
        title="FAQ | Scott Sells Chevys"
        description="Frequently asked questions about shopping new and used vehicles, trade value, payments, EVs, availability, service areas, and building your own deal."
        canonicalPath="/faq"
        jsonLd={[breadcrumbs([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]), faqSchema(FAQS)]}
      />
      <section className="ssc-hero">
        <div className="ssc-container py-10 md:py-16">
          <h1 className="ssc-display text-3xl md:text-5xl font-extrabold">Frequently Asked Questions</h1>
        </div>
      </section>
      <section className="ssc-section">
        <div className="ssc-container max-w-4xl">
          <div className="flex flex-wrap gap-2 mb-6">
            {CATS.map((c) => (
              <button key={c} type="button" onClick={() => setCat(c)} className={`ssc-chip ${cat === c ? "ssc-chip-active" : ""}`} data-testid={`faq-cat-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                {c}
              </button>
            ))}
          </div>
          <div className="space-y-3">
            {list.map((f, i) => (
              <details key={i} className="ssc-card" data-testid={`faq-${i}`}>
                <summary className="font-extrabold text-[var(--ssc-navy)] cursor-pointer">{f.q}</summary>
                <p className="mt-2 text-[var(--ssc-ink-2)]">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
